import { LangConstant } from "const";
import { getLabel } from "language";

export const getCommonLang = (key, options) => getLabel(`${LangConstant.NS_COMMON}:${key}`, options);

export const getNSLang = (namespace, key, options) => getLabel(`${namespace}:${key}`, options);
